enum WorkOrderStatusRevision {
	PAUSED = 'PAUSED',
	ACTIVE = 'ACTIVE',
}

export default WorkOrderStatusRevision;
